// extracted by mini-css-extract-plugin
module.exports = {"circle":"ProgressRing_circle__FwfB5","circleContainer":"ProgressRing_circleContainer__35em1","overlay":"ProgressRing_overlay__2ketJ"};